import { Navigate, RouteObject } from "react-router";
import { DataRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/data/data-route";
import { ItemsRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/items/items-route";
import { MicrobialRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/microbial/microbial-route";
import { StructuralRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/structural/structural-route";
import { VisualRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/visual/visual-route";
import { PhotosRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/photos/photos-route";
import { ReportFilesRoute } from "@/routes/processes/[processId]/htz/summaries/[summaryId]/items/[itemId]/report/files/report-files-route";

export const htzSummaryItemReportRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="data" replace />,
  },
  {
    path: "data",
    element: <DataRoute />,
  },
  {
    path: "items",
    element: <ItemsRoute />,
  },
  {
    path: "microbial",
    element: <MicrobialRoute />,
  },
  {
    path: "structural",
    element: <StructuralRoute />,
  },
  {
    path: "visual",
    element: <VisualRoute />,
  },
  {
    path: "photos",
    element: <PhotosRoute />,
  },
  {
    path: "files",
    element: <ReportFilesRoute />,
  },
];
